var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.38516H15.6766C14.9586 8.38516 14.3766 7.80313 14.3766 7.08516V2.5M20 8.38516L14.3766 2.5M20 8.38516V18.3067C20 18.3725 20 18.437 20 18.5004C20 20.1573 18.6569 21.5 17 21.5H7C5.34315 21.5 4 20.1573 4 18.5004C4 18.437 4 18.3725 4 18.3067L4.04297 6.75771C4.04297 6.31986 4.04297 5.89746 4.04297 5.49992C4.04297 3.84306 5.38612 2.5 7.04297 2.5H14.3766M7.5 12.5H16.7609M14.5 15L11.5 18.5L9.5 17M7.5 9.5H12.5M7.5 6.5H10",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.15bc0017decd0d57d37064f991dd01f3.svg";
export { ForwardRef as ReactComponent };